import React from 'react';

import KingpinBadge from 'kingpin/atoms/Badge';

import Tooltip from './Tooltip';

const AiGeneratedBadge = () => (
  <Tooltip content="Created by AI Insights Chat">
    <div style={{ width: 'fit-content', display: 'flex' }}>
      <KingpinBadge badgeType="Purple" text="AI" />
    </div>
  </Tooltip>
);

export default AiGeneratedBadge;
